import React from "react";
import DataTablePage from "@/components/common/DataTablePage";

export default function PromotionsPage() {
  return (
    <DataTablePage
      collection="promotions"
      eyebrow="Campaigns"
      title="Promotions & Campaigns"
      subtitle="Plan free-shipping thresholds, bundles, referrals and seasonal offers that lift AOV and acquisition."
      emptyDefault={{ type: "Seasonal", status: "draft" }}
      columns={[
        { key: "name", label: "Name", type: "text" },
        { key: "type", label: "Type", type: "select", options: ["Threshold", "Referral", "Bundle", "Seasonal", "Discount"] },
        { key: "status", label: "Status", type: "badge", options: ["draft", "scheduled", "live"] },
        { key: "start", label: "Start", type: "text" },
        { key: "end", label: "End", type: "text" },
        { key: "description", label: "Description", type: "textarea" },
      ]}
    />
  );
}
